import { string } from 'yup';

import { OffsetLimit } from '@playq/services-shared';
import { App } from '@playq/octopus2-apps';
import { LadderInstanceDimensions, Rank, TeamLadderInstanceDimensions, TeamRank } from '@playq/services-clerk';
import { Environment } from '@playq/octopus-common';

import { defaultTableTotal } from '/constants';

import { ILboardEntitiesState, ILboardInstanceScoresEnvState, ILboardInstanceScoresState } from './types';

export const defaultOffsetLimit = new OffsetLimit({ offset: 0, limit: 10 });

export const defaultApp = new App();

export const initialEnvState: ILboardInstanceScoresEnvState = {
  maybeBucketId: undefined,
  maybeBucket: undefined,
  selectedTeamDimension: undefined,
};

export const initialState: ILboardInstanceScoresState = {
  [Environment.Sandbox]: initialEnvState,
  [Environment.Live]: initialEnvState,
};

export const emptyArray: [] = [];

export const initialDimensionsState: ILboardEntitiesState<LadderInstanceDimensions | TeamLadderInstanceDimensions> = {
  offsetLimit: defaultOffsetLimit,
  total: defaultTableTotal,
  entities: emptyArray,
  pending: false,
};

export const queryCache = {
  staleTime: 2 * 60 * 1000,
  cacheTime: 5 * 60 * 1000,
};

export const initialTeamDimensionsState = initialDimensionsState as ILboardEntitiesState<LadderInstanceDimensions>;

export const initialScoresState: ILboardEntitiesState<Rank | TeamRank> = {
  offsetLimit: defaultOffsetLimit,
  total: defaultTableTotal,
  entities: undefined,
  pending: false,
};

export const teamSegmentDialogOptions = {
  placeholder: 'Type the Team Segment',
  schema: string().trim().required('Team Segment is required'),
  title: 'Team Segment',
};

export const defaultLadderPromotions = {
  [Environment.Live]: false,
  [Environment.Sandbox]: false,
};
